/**
 * Single mapping table: application ParamName → Vital flat setting key.
 * PresetModel, compiler, editor metadata, and tests must agree via this table.
 */
export const PARAM_TO_VITAL = {
    polyphony: "polyphony",
    voice_mode: "legato", // 0 poly → legato 0; mono/legato encoded with polyphony+legato in emit
    voice_transpose: "voice_transpose",
    glide_time: "portamento_time",
    glide_force: "portamento_force",
    osc1_level: "osc_1_level",
    osc2_level: "osc_2_level",
    osc3_level: "osc_3_level",
    osc1_transpose: "osc_1_transpose",
    osc2_transpose: "osc_2_transpose",
    osc3_transpose: "osc_3_transpose",
    osc1_tune: "osc_1_tune",
    osc2_tune: "osc_2_tune",
    osc3_tune: "osc_3_tune",
    osc1_pan: "osc_1_pan",
    osc2_pan: "osc_2_pan",
    osc3_pan: "osc_3_pan",
    osc1_phase: "osc_1_phase",
    osc2_phase: "osc_2_phase",
    osc3_phase: "osc_3_phase",
    osc1_random_phase: "osc_1_random_phase",
    osc2_random_phase: "osc_2_random_phase",
    osc3_random_phase: "osc_3_random_phase",
    osc1_unison_voices: "osc_1_unison_voices",
    osc2_unison_voices: "osc_2_unison_voices",
    osc3_unison_voices: "osc_3_unison_voices",
    osc1_unison_detune: "osc_1_unison_detune",
    osc2_unison_detune: "osc_2_unison_detune",
    osc3_unison_detune: "osc_3_unison_detune",
    osc1_unison_blend: "osc_1_unison_blend",
    osc2_unison_blend: "osc_2_unison_blend",
    osc3_unison_blend: "osc_3_unison_blend",
    osc1_stereo_spread: "osc_1_stereo_spread",
    osc2_stereo_spread: "osc_2_stereo_spread",
    osc3_stereo_spread: "osc_3_stereo_spread",
    osc1_frame_spread: "osc_1_frame_spread",
    osc2_frame_spread: "osc_2_frame_spread",
    osc3_frame_spread: "osc_3_frame_spread",
    osc1_wave_frame: "osc_1_wave_frame",
    osc2_wave_frame: "osc_2_wave_frame",
    osc3_wave_frame: "osc_3_wave_frame",
    osc1_spectral_morph_amount: "osc_1_spectral_morph_amount",
    osc2_spectral_morph_amount: "osc_2_spectral_morph_amount",
    osc3_spectral_morph_amount: "osc_3_spectral_morph_amount",
    osc1_phase_distortion_amount: "osc_1_distortion_amount",
    osc2_phase_distortion_amount: "osc_2_distortion_amount",
    osc3_phase_distortion_amount: "osc_3_distortion_amount",
    osc1_destination_filter: "filter_1_osc1_input",
    osc2_destination_filter: "filter_1_osc2_input",
    osc3_destination_filter: "filter_1_osc3_input",
    sub_on: "sub_on",
    sub_level: "sub_level",
    sub_transpose: "sub_transpose",
    sub_pan: "sub_pan",
    sub_waveform: "sub_waveform",
    sub_destination_filter: "filter_1_sample_input", // sub uses dedicated path; sample input kept separate in emit
    filter_cutoff: "filter_1_cutoff",
    filter_resonance: "filter_1_resonance",
    filter_blend: "filter_1_blend",
    filter_on: "filter_1_on",
    filter_drive: "filter_1_drive",
    filter_keytrack: "filter_1_keytrack",
    filter_mix: "filter_1_mix",
    filter_model: "filter_1_model",
    filter_style: "filter_1_style",
    filter_osc1_input: "filter_1_osc1_input",
    filter_osc2_input: "filter_1_osc2_input",
    filter_osc3_input: "filter_1_osc3_input",
    filter_sample_input: "filter_1_sample_input",
    env1_delay: "env_1_delay",
    env1_attack: "env_1_attack",
    env1_hold: "env_1_hold",
    env1_decay: "env_1_decay",
    env1_sustain: "env_1_sustain",
    env1_release: "env_1_release",
    env1_attack_power: "env_1_attack_power",
    env1_decay_power: "env_1_decay_power",
    env1_release_power: "env_1_release_power",
    env2_delay: "env_2_delay",
    env2_attack: "env_2_attack",
    env2_hold: "env_2_hold",
    env2_decay: "env_2_decay",
    env2_sustain: "env_2_sustain",
    env2_release: "env_2_release",
    env2_attack_power: "env_2_attack_power",
    env2_decay_power: "env_2_decay_power",
    env2_release_power: "env_2_release_power",
    env3_delay: "env_3_delay",
    env3_attack: "env_3_attack",
    env3_hold: "env_3_hold",
    env3_decay: "env_3_decay",
    env3_sustain: "env_3_sustain",
    env3_release: "env_3_release",
    env3_attack_power: "env_3_attack_power",
    env3_decay_power: "env_3_decay_power",
    env3_release_power: "env_3_release_power",
    env4_delay: "env_4_delay",
    env4_attack: "env_4_attack",
    env4_hold: "env_4_hold",
    env4_decay: "env_4_decay",
    env4_sustain: "env_4_sustain",
    env4_release: "env_4_release",
    env4_attack_power: "env_4_attack_power",
    env4_decay_power: "env_4_decay_power",
    env4_release_power: "env_4_release_power",
    lfo1_frequency: "lfo_1_frequency",
    lfo2_frequency: "lfo_2_frequency",
    lfo3_frequency: "lfo_3_frequency",
    lfo4_frequency: "lfo_4_frequency",
    lfo5_frequency: "lfo_5_frequency",
    lfo6_frequency: "lfo_6_frequency",
    lfo7_frequency: "lfo_7_frequency",
    lfo8_frequency: "lfo_8_frequency",
    macro_control_1: "macro_control_1",
    macro_control_2: "macro_control_2",
    macro_control_3: "macro_control_3",
    macro_control_4: "macro_control_4",
    volume: "volume",
    delay_on: "delay_on",
    delay_dry_wet: "delay_dry_wet",
    delay_feedback: "delay_feedback",
    delay_tempo: "delay_tempo",
    reverb_on: "reverb_on",
    reverb_dry_wet: "reverb_dry_wet",
    reverb_decay: "reverb_decay_time",
    reverb_size: "reverb_size",
    chorus_on: "chorus_on",
    chorus_dry_wet: "chorus_dry_wet",
    chorus_depth: "chorus_mod_depth",
    chorus_feedback: "chorus_feedback",
    phaser_on: "phaser_on",
    phaser_dry_wet: "phaser_dry_wet",
    phaser_depth: "phaser_mod_depth",
    phaser_feedback: "phaser_feedback",
    flanger_on: "flanger_on",
    flanger_dry_wet: "flanger_dry_wet",
    flanger_depth: "flanger_mod_depth",
    flanger_feedback: "flanger_feedback",
    distortion_on: "distortion_on",
    distortion_drive: "distortion_drive",
    distortion_mix: "distortion_mix",
    compressor_on: "compressor_on",
    compressor_mix: "compressor_mix",
    compressor_attack: "compressor_attack",
    compressor_release: "compressor_release",
};
export const MOD_SOURCE_TO_VITAL = {
    lfo_1: "lfo_1",
    lfo_2: "lfo_2",
    lfo_3: "lfo_3",
    lfo_4: "lfo_4",
    lfo_5: "lfo_5",
    lfo_6: "lfo_6",
    lfo_7: "lfo_7",
    lfo_8: "lfo_8",
    env_1: "env_1",
    env_2: "env_2",
    env_3: "env_3",
    env_4: "env_4",
    macro_1: "macro_control_1",
    macro_2: "macro_control_2",
    macro_3: "macro_control_3",
    macro_4: "macro_control_4",
    note: "note",
    velocity: "velocity",
    aftertouch: "aftertouch",
    mod_wheel: "mod_wheel",
    random: "random_1",
    stereo_random: "random_2",
};
export const MOD_DEST_TO_VITAL = {
    osc_1_level: "osc_1_level",
    osc_2_level: "osc_2_level",
    osc_3_level: "osc_3_level",
    osc_1_transpose: "osc_1_transpose",
    osc_2_transpose: "osc_2_transpose",
    osc_3_transpose: "osc_3_transpose",
    osc_1_pan: "osc_1_pan",
    osc_2_pan: "osc_2_pan",
    osc_3_pan: "osc_3_pan",
    osc_1_wave_frame: "osc_1_wave_frame",
    osc_2_wave_frame: "osc_2_wave_frame",
    osc_3_wave_frame: "osc_3_wave_frame",
    voice_transpose: "voice_transpose",
    filter_cutoff: "filter_1_cutoff",
    filter_resonance: "filter_1_resonance",
    filter_drive: "filter_1_drive",
    filter_mix: "filter_1_mix",
    volume: "volume",
    reverb_dry_wet: "reverb_dry_wet",
    delay_dry_wet: "delay_dry_wet",
    chorus_dry_wet: "chorus_dry_wet",
    phaser_dry_wet: "phaser_dry_wet",
    distortion_drive: "distortion_drive",
    macro_control_1: "macro_control_1",
    macro_control_2: "macro_control_2",
    macro_control_3: "macro_control_3",
    macro_control_4: "macro_control_4",
};
//# sourceMappingURL=param-map.js.map